module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDE4IDE4Ij4KICAgIDxwYXRoIGZpbGw9IiMwMDAiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTkgNi4yOTlsNS43NC01Ljc0YTEuOTEgMS45MSAwIDAgMSAyLjcgMi43MDFMMTEuNzAyIDlsNS43NCA1Ljc0YTEuOTEgMS45MSAwIDAgMS0yLjcwMSAyLjdMOSAxMS43MDJsLTUuNzQgNS43NGExLjkxIDEuOTEgMCAwIDEtMi43LTIuNzAxTDYuMjk4IDkgLjU1OSAzLjI2QTEuOTEgMS45MSAwIDEgMSAzLjI2LjU2TDkgNi4yOTh6Ii8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/close.svg
// module id = 765
// module chunks = 2